import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import includes from 'lodash/includes';
import { fetchGodfatherLevels } from '../../../../../actions/entities/statistics/godfather';

const LEVELS = [0, 1, 2, 3, 4, 5, 9, 15, 20, 40]

class GodfatherLevelsWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ranking: null,
            order: 'asc',
            orderType: 'godchild',
        };
    }

    componentDidMount() {
        const onSuccess = (response) => {
            this.setState({ levels: response })
        };
        this.props.dispatch(fetchGodfatherLevels(onSuccess));
    }

    orderRank(type) {
        this.setState({
            levels: orderBy(this.state.levels, [type, 'godchild'], [this.state.order]),
            order: this.state.order === 'asc' ? 'desc' : 'asc',
            orderType: type,
        });
    }

    render() {
        const { levels } = this.state;

        return (
            <div className="box">
                <div className="box-header with-border">
                    <h3 className="box-title pull-left">
                        <i className="fa fa-list-ol"/> Levels
                    </h3><br />
                </div>
                <div className="box-body">
                    <div
                        style={{ overflow: 'auto', marginBottom: '1rem', maxHeight: '700px',  }}
                        className="table-responsive"
                    >
                        <table className="table table-bordered no-margin">
                            <thead>
                                <tr>
                                    <th className="theadRanking" onClick={() => this.orderRank('godchild')}>
                                        Godchild
                                    </th>
                                    <th className="theadRanking" onClick={() => this.orderRank('nbGodfather')}>
                                        Users
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                map(levels, ({ godchild, nbGodfather }) => {
                                    return (
                                        <tr id={godchild} className={includes(LEVELS, godchild) && "level"}>
                                            <th className="text-center">{godchild}</th>
                                            <th className="text-center">{nbGodfather}</th>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    dispatch => ({ dispatch })
)(GodfatherLevelsWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/Godfather/Widgets/GodfatherLevels/index.js